import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ReactMarkdown from 'react-markdown';
import { Typography, Icon, Box, StackWrap, StackView, Button, Spacer } from '@telus-uds/components-web';
import { StatusSuccess, StatusError, StatusInfo } from '@telus-uds/palette-allium/build/web/icons';

import MainLayout from '../../components/main-layout/MainLayout';
import { replaceTemplateVars } from '../../utils/templater';
import { mdCompsMapping } from '../../utils/md-components';

function StatusPage() {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const statusDisplay = {
    success: {
      icon: StatusSuccess,
      color: 'success',
      heading: t('status.success'),
    },
    cancelled: {
      icon: StatusInfo,
      color: 'warning',
      heading: t('status.cancelled'),
    },
    failure: {
      icon: StatusError,
      color: 'warning',
      heading: t('status.failed'),
    },
  };

  const { status = 'failure', shouldRetry = false, message = t('status.failed'), outcome, path } = location.state || {};

  const icon = statusDisplay[status].icon;
  const color = statusDisplay[status].color;
  const headingText = statusDisplay[status].heading;
  const displayMessage = outcome?.[status]?.[i18n.language]
    ? replaceTemplateVars(outcome?.[status]?.[i18n.language], { error: message })
    : message;

  const retry = () => {
    navigate(`/${path}`);
  };

  return (
    <MainLayout>
      <Box flex direction="column" vertical={{ xs: 2, sm: 3, lg: 5, xl: 6 }} style={{ minHeight: '100vh' }}>
        <StackWrap vertical={2} tokens={{ alignItems: 'center', justifyContent: 'flex-start' }}>
          <Icon icon={icon} variant={{ size: 'extraLarge', color }} />
          <Typography align="left" tag="h2" variant={{ size: 'h2' }}>
            {headingText}
          </Typography>
        </StackWrap>
        <Spacer space={4} />
        <Typography align="left">
          <ReactMarkdown components={mdCompsMapping}>{displayMessage}</ReactMarkdown>
        </Typography>
        {shouldRetry && (
          <>
            <Spacer space={4} />
            <StackView
              tokens={{
                alignItems: 'center',
                justifyContent: 'center',
                flexGrow: 1,
              }}
            >
              <Button align="center" onPress={retry} variant={{ priority: 'high' }}>
                {t('retry')}
              </Button>
            </StackView>
          </>
        )}
      </Box>
    </MainLayout>
  );
}

export default StatusPage;
